import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title } from './ListTitle.style';

const ListTitle = ({ children, component, testID, title, className }) => (
  <Container className={className} component={component} id={testID}>
    <Title>{title}</Title>
    {children}
  </Container>
);

ListTitle.defaultProps = {
  title: '',
  children: [],
  component: 'li',
  testID: undefined,
  className: null,
};

ListTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  component: PropTypes.string,
  testID: PropTypes.string,
  className: PropTypes.string,
};

export default React.memo(ListTitle);
